import { CoachingType, GoalStatus, Opportunity } from '../general';

import { adjustOpportunity } from './adjust-opportunity.function';
import {
    determineOpportunityType,
    determineOpportunityTypeByComponent,
} from './determine-opportunity-type.function';
import { OpportunityView } from './opportunity-view.model';
import { overrideCoachTypeByComponent } from './override-coach-type.function';
import { patchOpportunity } from './patch-opportunity.function';

/** items must be a subset of lookupItems */
export function opportunityToViewTransformer(
    items: Opportunity[],
    lookupItems: Opportunity[],
    parentsOnly = true,
): OpportunityView[] {
    const result: OpportunityView[] = [];

    const finalItems = items || [];
    const finalLookupItems = lookupItems || [];
    finalItems.forEach((e) => {
        if (parentsOnly && e.parentMetricId != null) {
            return;
        }

        patchOpportunity(e);

        // TODO post-refactor oa.model.ts:mapOppsWithComponents
        const coachedComponents = finalLookupItems.filter(
            (c) =>
                c.parentMetricId === e.metricId &&
                c.userId === e.userId &&
                (c.goalStatusId === GoalStatus.ACTIVE ||
                    c.coachTypeId === CoachingType.COACHED),
        );
        coachedComponents.sort((a, b) => {
            const va =
                a.estCompletionForGoal == null
                    ? Number.MIN_SAFE_INTEGER
                    : +new Date(a.estCompletionForGoal);
            const vb =
                b.estCompletionForGoal == null
                    ? Number.MIN_SAFE_INTEGER
                    : +new Date(b.estCompletionForGoal);
            return vb - va;
        });

        let oppType = determineOpportunityType(e);
        let coachingType = e.coachTypeId;

        if (coachedComponents && coachedComponents.length !== 0) {
            // TODO post-refactor same order as in oa.model.ts:mapOppsWithComponents
            coachingType = overrideCoachTypeByComponent(
                e,
                coachedComponents[0],
                oppType,
            );
            oppType = determineOpportunityTypeByComponent(
                e,
                coachedComponents[0],
                oppType,
            );
        }

        const next: OpportunityView = {
            metricId: e.metricId,
            percentToGoal: e.percentToGoal,
            percentToTarget: e.percentToTarget,
            label: e.metricShortName,
            goalBorderColour: null,
            goalColour: null,
            goalLabel: null,
            goalLabelColour: null,
            goalIcon: null,
            goalBadgeColour: null,
            goalBadgeLabel: null,
            goalBadgeLabelColour: null,
            targetColour: e.targetThresholdColour,
            targetLabel: null,
            coachingType,
            oppType,
            numCoachedComponents: coachedComponents.length,
        };

        adjustOpportunity(e, oppType, next);

        result.push(next);
    });

    return result;
}
